export const DEFAULT_CRM_TOKEN = 'idkt5jr7sfo';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = [];
export const faqArticleIds = ['3', '4', '5'];
